
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/downloads",
      function () {
        return require("private-next-pages/downloads.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/downloads"])
      });
    }
  